// extracted by mini-css-extract-plugin
module.exports = {"intro":"NewsSection_intro__7n_rD","title":"NewsSection_title__mBFvL","list":"NewsSection_list__kQJEp","item":"NewsSection_item__BFtDr","ctaBox":"NewsSection_ctaBox__QVJlM"};